// Stripe Configuration
// Replace these values with your actual Stripe account details

export const STRIPE_CONFIG = {
  // Your Stripe publishable key (starts with 'pk_test_' for test mode, 'pk_live_' for live mode)
  publishableKey: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || 'pk_test_your_test_key_here',
  
  // Currency for payments (default: USD)
  currency: 'usd',
  
  // Payment method types to accept
  paymentMethodTypes: ['card'],
  
  // Test card numbers for development
  testCards: {
    success: '4242424242424242',
    decline: '4000000000000002',
    insufficientFunds: '4000000000009995',
    expired: '4000000000000069',
    incorrectCvc: '4000000000000127',
    processingError: '4000000000000119',
  },
  
  // Default styling for Stripe Elements
  elementStyles: {
    base: {
      fontSize: '16px',
      color: '#121616',
      fontFamily: '"IBM Plex Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
      '::placeholder': {
        color: '#9CB0BD',
      },
    },
    invalid: {
      color: '#dc3545',
    },
  },
};

// Helper function to check if Stripe is properly configured
export const isStripeConfigured = () => {
  const key = STRIPE_CONFIG.publishableKey;
  return key && key !== 'pk_test_your_test_key_here' && key.startsWith('pk_');
};

// Helper function to get Stripe mode (test/live)
export const getStripeMode = () => {
  const key = STRIPE_CONFIG.publishableKey;
  if (key.startsWith('pk_test_')) return 'test';
  if (key.startsWith('pk_live_')) return 'live';
  return 'unknown';
};

export default STRIPE_CONFIG;
